(function () {
  if (window.__ksFlashAnnouncement) return;
  window.__ksFlashAnnouncement = true;

  function pad(num) {
    return String(num).padStart(2, '0');
  }

  function hideBar(bar) {
    bar.classList.add('is-hidden');
    bar.hidden = true;
  }

  function updateTimer(bar) {
    var endTs = parseInt(bar.getAttribute('data-end-ts'), 10) * 1000;
    if (!endTs) return;

    var distance = endTs - Date.now();

    if (distance <= 0) {
      if (bar.getAttribute('data-hide-on-complete') === 'true') {
        hideBar(bar);
      }
      return;
    }

    var totalHours = Math.floor(distance / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

    var hoursEl = bar.querySelector('[data-ks-hours]');
    var minsEl = bar.querySelector('[data-ks-mins]');
    var secsEl = bar.querySelector('[data-ks-secs]');

    if (hoursEl) hoursEl.textContent = pad(totalHours);
    if (minsEl) minsEl.textContent = pad(minutes);
    if (secsEl) secsEl.textContent = pad(seconds);
  }

  function initBar(bar) {
    if (bar.hasAttribute('data-ks-flash-init')) return;
    bar.setAttribute('data-ks-flash-init', 'true');

    var closeBtn = bar.querySelector('.ks-flash-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        hideBar(bar);
      });
    }

    updateTimer(bar);

    var intervalId = window.setInterval(function () {
      updateTimer(bar);
    }, 1000);

    bar.setAttribute('data-ks-flash-interval', String(intervalId));
  }

  function scan() {
    document.querySelectorAll('[data-ks-flash-timer]:not([data-ks-flash-init])').forEach(initBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(scan, 50);
  });
})();
